export const quotes = [
  {
    id: 39,
    quote:
      "You cannot build character and courage by taking away one's initiative and independence.",
    author: 'Abraham Lincoln',
    tag: 'character',
  },
  {
    id: 8315,
    quote:
      "Every individual's work, whether it be literature or music or pictures or anything else, is always a portrait of oneself, and the more one tries to conceal oneself the more clearly will one's character appear in spite of oneself.",
    author: 'Samuel Butler',
    tag: 'character',
  },
  {
    id: 762,
    quote:
      'Good character is that quality which makes one dependable whether being watched or not, which makes one truthful when it is to one’s advantage to be a little less than truthful.',
    author: 'Arthur S. Adams',
    tag: 'character',
  },
  {
    id: 9025,
    quote:
      "The measure of one's real character is what one would do if one knew one would never be found out.",
    author: 'Thomas B. Macaulay',
    tag: 'character',
  },
  {
    id: 13,
    quote:
      'The force, the mass of character, mind, heart or soul that one can put into any work is the most important factor in that work.',
    author: 'A.P. Peabody',
    tag: 'character',
  },
  {
    id: 8021,
    quote:
      'The noblest contribution which any person can make for the benefit of posterity, is that of character. The richest bequest which any person can leave to the youth of his native land, is that of a shining, spotless example.',
    author: 'Robert C. Winthrop',
    tag: 'character',
  },
  {
    id: 6526,
    quote:
      'Character is formed, not by laws, commands, and decrees, but by quiet influence, unconscious suggestion and personal guidance.',
    author: 'Marion L. Burton',
    tag: 'character',
  },
  {
    id: 996,
    quote:
      'Fame is what you have taken, character is what you give. When to this truth you awaken, then you begin to live.',
    author: 'Bayard Taylor',
    tag: 'character',
  },
  {
    id: 2232,
    quote:
      'The character that needs law to mend it is hardly worth the tinkering.',
    author: 'Douglas Jerrold',
    tag: 'character',
  },
  {
    id: 10181,
    quote:
      'To wilful people, the injuries that they themselves procure must be their schoolmasters.',
    author: 'William Shakespeare',
    tag: 'character',
  },
  {
    id: 9815,
    quote: 'Every person is a volume, if you know how to read them.',
    author: 'William Ellery Channing',
    tag: 'character',
  },
  {
    id: 604,
    quote: 'The dearest to me are those of best character.',
    author: 'Arabian Proverb',
    tag: 'character',
  },
  {
    id: 10355,
    quote:
      'Character is a by-product; it is produced in the great manufacture of daily duty',
    author: 'Woodrow Wilson',
    tag: 'character',
  },
  {
    id: 4630,
    quote:
      "A person's reputation is the opinion people have of them; their character is what they really are.",
    author: 'Jack Miner',
    tag: 'character',
  },
  {
    id: 6290,
    quote:
      'You can easily judge the character of others by how they treat those who can do nothing for them or to them.',
    author: 'Malcolm Forbes',
    tag: 'character',
  },
  {
    id: 5042,
    quote:
      'Talents are best nurtured in solitude; character is best formed in the stormy billows of the world.',
    author: 'Johann Wolfgang Von Goethe',
    tag: 'character',
  },
  {
    id: 1795,
    quote:
      'In people of the highest character and noblest genius there is to be found an insatiable desire for honor, command, power, and glory.',
    author: 'Cicero',
    tag: 'character',
  },
  {
    id: 137,
    quote: "Wherever one goes to dwell, one's character goes too.",
    author: 'African Proverb',
    tag: 'character',
  },
  {
    id: 10284,
    quote: 'Don’t mistake personality for character.',
    author: 'Wilma Askinas',
    tag: 'character',
  },
  {
    id: 5740,
    quote:
      'Society asks of most people more than sheer intellectual ability-it demands also moral hardiness, self-discipline, a competitive spirit and other qualities that in more old-fashioned terms we might simply call character.',
    author: 'Julius Adams Stratton',
    tag: 'character',
  },
  {
    id: 1019,
    quote:
      'Characters never change. Opinions alter; characters are only developed.',
    author: 'Benjamin Disraeli',
    tag: 'character',
  },
  {
    id: 4209,
    quote:
      "One's ledger does not tell what one is, or what one is worth. Count what is in a person, not what is on them, if you would know what they are worth-whether rich or poor.",
    author: 'Henry Ward Beecher',
    tag: 'character',
  },
  {
    id: 8203,
    quote:
      'A character standard is far more important than ever a gold standard. The success of all economic systems is still dependent upon both righteous leaders and righteous people.',
    author: 'Roger Babson',
    tag: 'character',
  },
  {
    id: 5274,
    quote: 'Character is the real foundation of all worthwhile success.',
    author: 'John Hays Hammond',
    tag: 'character',
  },
  {
    id: 5189,
    quote:
      'The most important thing for a young person is to establish a credit-a reputation, character.',
    author: 'John D. Rockefeller',
    tag: 'character',
  },
  {
    id: 7543,
    quote:
      'The highest of characters is a person who is as ready to pardon the moral errors of all as if they were every day guilty of them themself; and as cautious of committing a fault as if they never forgave one.',
    author: 'Pliny the Younger',
    tag: 'character',
  },
  {
    id: 8949,
    quote:
      'I care not what others think of what I do, but I care very much about what I think of what I do: That is character!',
    author: 'Theodore Roosevelt',
    tag: 'character',
  },
  {
    id: 5599,
    quote:
      'I never knew an early-rising, hard-working, prudent person, careful of their earnings and strictly honest, who complained of hard luck.',
    author: 'Joseph Addison',
    tag: 'character',
  },
  {
    id: 6088,
    quote:
      'Before you are five and twenty you must establish a character that will serve you all your life.',
    author: 'Lord Collingwood',
    tag: 'character',
  },
  {
    id: 769,
    quote:
      'People best show their character in trifles, where they are not on guard.',
    author: 'Arthur Schopenhauer',
    tag: 'character',
  },
  {
    id: 1299,
    quote: 'The character of a generation is moulded by personal character.',
    author: 'Brooke Foss Westcott',
    tag: 'character',
  },
  {
    id: 2009,
    quote: 'Character is a diamond that scratches every other stone.',
    author: 'Cyrus R. Bartol',
    tag: 'character',
  },
  {
    id: 699,
    quote:
      'It’s only by the hard blows of adverse fortune that character is tooled.',
    author: 'Arnold Glasow',
    tag: 'character',
  },
  {
    id: 7754,
    quote: 'Judge of your natural character by what you do in your dreams.',
    author: 'Ralph Waldo Emerson',
    tag: 'character',
  },
  {
    id: 4275,
    quote: 'Character is destiny.',
    author: 'Heraclitus',
    tag: 'character',
  },
  {
    id: 10090,
    quote:
      'Character development is the great, if not the sole, aim of education.',
    author: 'William O’Shea',
    tag: 'character',
  },
  {
    id: 262,
    quote:
      'Only what we have wrought into our character during life can we take way with us.',
    author: 'Alexander Humboldt',
    tag: 'character',
  },
  {
    id: 5287,
    quote:
      'Character is power; it makes friends, draws patronage and support, and opens a sure way to wealth, honor and happiness.',
    author: 'John Howe',
    tag: 'character',
  },
  {
    id: 648,
    quote:
      'Character is that which reveals moral purpose, exposing the class of things people choose or avoid.',
    author: 'Aristotle',
    tag: 'character',
  },
  {
    id: 10609,
    quote:
      'To be independent is the business of a few only; it is the privilege of the strong.',
    author: 'Friedrich Wilhelm Nietzsche',
    tag: 'character',
  },
  {
    id: 5943,
    quote:
      'You can never have a greater or a less dominion than over yourself.',
    author: 'Leonardo da Vinci',
    tag: 'character',
  },
  {
    id: 4419,
    quote:
      'Fame is a vapor, popularity an accident, riches take wings. Only one thing endures, and that is character.',
    author: 'Horace Greeley',
    tag: 'character',
  },
  {
    id: 131,
    quote: 'It is easy to be brave from a safe distance.',
    author: 'Aesop',
    tag: 'courage',
  },
  {
    id: 8952,
    quote: 'Don’t foul, don’t flinch-hit the line hard.',
    author: 'Theodore Roosevelt',
    tag: 'courage',
  },
  {
    id: 7762,
    quote:
      'Whatever you do, you need courage. Whatever course you decide upon, there is always someone to tell you you are wrong.',
    author: 'Ralph Waldo Emerson',
    tag: 'courage',
  },
  {
    id: 7709,
    quote: 'Courage without conscience is a wild beast.',
    author: 'Ralph Ingersoll',
    tag: 'courage',
  },
  {
    id: 10591,
    quote: 'Bravery never goes out of style.',
    author: 'William Makepeace Thackeray',
    tag: 'courage',
  },
  {
    id: 7290,
    quote:
      'It takes vision and courage to create—it takes faith and courage to prove.',
    author: 'Owen D. Young',
    tag: 'courage',
  },
  {
    id: 6551,
    quote:
      'It is curious that physical courage should be so common in the world, and moral courage so rare.',
    author: 'Mark Twain',
    tag: 'courage',
  },
  {
    id: 7761,
    quote: 'Courage consists in equality to the problem before us.',
    author: 'Ralph Waldo Emerson',
    tag: 'courage',
  },
  {
    id: 9625,
    quote: 'The will to do, the soul to dare.',
    author: 'Walter Scott',
    tag: 'courage',
  },
  {
    id: 483,
    quote: 'One individual with courage makes a majority.',
    author: 'Andrew Jackson',
    tag: 'courage',
  },
  {
    id: 5784,
    quote:
      'Hope awakens courage. One who can implant courage in the human soul is the best physician.',
    author: 'Karl Ludwig von Knebel',
    tag: 'courage',
  },
  {
    id: 10314,
    quote:
      'Courage is rightly esteemed the first of human qualities because it’s the quality which guarantees all others.',
    author: 'Winston Churchill',
    tag: 'courage',
  },
  {
    id: 10313,
    quote:
      'Courage is what it takes to stand up and speak; courage is also what it takes to sit down and listen.',
    author: 'Winston Churchill',
    tag: 'courage',
  },
  {
    id: 2980,
    quote: 'The only security is courage.',
    author: 'François de La Rochefoucauld',
    tag: 'courage',
  },
  {
    id: 7483,
    quote: 'Every individual of courage is an individual of their word.',
    author: 'Pierre Corneille',
    tag: 'courage',
  },
  {
    id: 1350,
    quote:
      'Courage is not simply one of the virtues, but the form of every virtue at the testing point.',
    author: 'C.S. Lewis',
    tag: 'courage',
  },
  {
    id: 7528,
    quote: 'Courage in danger is half the battle.',
    author: 'Plautus',
    tag: 'courage',
  },
  {
    id: 415,
    quote: 'Life shrinks or expands in proportion to one’s courage.',
    author: 'Anaïs Nin',
    tag: 'courage',
  },
  {
    id: 6805,
    quote:
      'The strongest, most generous and proudest of all virtues is courage.',
    author: 'Michel de Montaigne',
    tag: 'courage',
  },
  {
    id: 2082,
    quote:
      'Courage is a special kind of knowledge: the knowledge of how to fear what ought to be feared and how not to fear what ought not to be feared.',
    author: 'David Ben-Gurion',
    tag: 'courage',
  },
  {
    id: 7270,
    quote: 'Courage conquers all things.',
    author: 'Ovid',
    tag: 'courage',
  },
  {
    id: 5417,
    quote:
      'Courage and perseverance have a magical talisman, before which difficulties disappear and obstacles vanish into air.',
    author: 'John Quincy Adams',
    tag: 'courage',
  },
  {
    id: 3475,
    quote:
      'Success is never final and Failure never fatal. It’s courage that counts.',
    author: 'George F. Tilton',
    tag: 'courage',
  },
  {
    id: 7760,
    quote: 'A great part of courage is having done the thing before.',
    author: 'Ralph Waldo Emerson',
    tag: 'courage',
  },
  {
    id: 6056,
    quote: 'Whatever is worth doing at all is worth doing well.',
    author: 'Lord Chesterfield',
    tag: 'doing',
  },
  {
    id: 4175,
    quote:
      'It takes less time to do a thing right than to explain why you did it wrong.',
    author: 'Henry Wadsworth Longfellow',
    tag: 'doing',
  },
  {
    id: 3599,
    quote:
      'If you have something to do that is worthwhile doing, don’t talk about it, but do it. After you have done it, your friends and enemies will talk about it.',
    author: 'George W. Blount',
    tag: 'doing',
  },
  {
    id: 9057,
    quote: 'People do less than they ought, unless they do all that they can.',
    author: 'Thomas Carlyle',
    tag: 'doing',
  },
  {
    id: 5446,
    quote:
      'Doing is the great thing. For if, resolutely, people do what is right, in time they come to like doing it.',
    author: 'John Ruskin',
    tag: 'doing',
  },
  {
    id: 7927,
    quote:
      'The shortest way to do many things is to do only one thing at a time.',
    author: 'Richard Cecil',
    tag: 'doing',
  },
  {
    id: 1342,
    quote:
      'Not merely what we do, but what we try to do and why, are the true interpreters of what we are.',
    author: 'C.H. Woodward',
    tag: 'doing',
  },
  {
    id: 3489,
    quote: 'The shortest answer is doing.',
    author: 'George Herbert',
    tag: 'doing',
  },
  {
    id: 490,
    quote: 'So much one person can do that does both act and know.',
    author: 'Andrew Marvell',
    tag: 'doing',
  },
  {
    id: 9694,
    quote:
      'A wise person said: "As I grow older I pay less attention to what people say. I just watch what they do.',
    author: 'Wilfred A. Peterson',
    tag: 'doing',
  },
  {
    id: 7157,
    quote:
      'I will just create, and if it works, it works, and if it doesn’t, I’ll create something else. I don’t have any limitations on what I think I could do or be.',
    author: 'Oprah Winfrey',
    tag: 'doing',
  },
  {
    id: 6558,
    quote:
      'Make it a point to do something every day that you don’t want to do. This is the golden rule for acquiring the habit of doing your duty without pain.',
    author: 'Mark Twain',
    tag: 'doing',
  },
  {
    id: 1070,
    quote: 'Well done is better than well said.',
    author: 'Benjamin Franklin',
    tag: 'doing',
  },
  {
    id: 6521,
    quote:
      'One never notices what has been done; one can only see what remains to be done.',
    author: 'Marie Curie',
    tag: 'doing',
  },
  {
    id: 5555,
    quote:
      'I feel that the greatest reward for doing is the opportunity to do more.',
    author: 'Jonas Salk',
    tag: 'doing',
  },
  {
    id: 655,
    quote:
      'One must learn by doing the thing, for though you think you know it, you have no certainty until you try.',
    author: 'Aristotle',
    tag: 'doing',
  },
  {
    id: 7404,
    quote:
      'Thinking well is wise; planning well; wiser; doing well wisest and best of all.',
    author: 'Persian Proverb',
    tag: 'doing',
  },
  {
    id: 6057,
    quote: 'Do as you would be done by, is the surest method of pleasing.',
    author: 'Lord Chesterfield',
    tag: 'doing',
  },
  {
    id: 9056,
    quote:
      'Everywhere in life the true question is, not what we have gained, but what we do.',
    author: 'Thomas Carlyle',
    tag: 'doing',
  },
  {
    id: 4631,
    quote: 'Many enjoy the shade ... but few rake leaves.',
    author: 'Jack Morton',
    tag: 'doing',
  },
  {
    id: 6902,
    quote:
      'It is not only what we do, but also what we do not do, for which we are accountable.',
    author: 'Moliere',
    tag: 'doing',
  },
  {
    id: 464,
    quote: 'What one does easily, one does well.',
    author: 'Andrew Carnegie',
    tag: 'doing',
  },
  {
    id: 2398,
    quote:
      'The greatest thing in the world is for a person to be able to do something well, and say nothing about it.',
    author: 'Edgar Watson Howe',
    tag: 'doing',
  },
  {
    id: 18,
    quote: 'Whatever fortune brings, don’t be afraid of doing things.',
    author: 'A.A. Milne',
    tag: 'doing',
  },
  {
    id: 2313,
    quote:
      'The world is divided into people who do things and people who get the credit. Try, if you can, to belong to the first class. There’s far less competition.',
    author: 'Dwight Morrow',
    tag: 'doing',
  },
  {
    id: 8110,
    quote: 'The two basic processes of education are knowing and valuing.',
    author: 'Robert J. Havighurst',
    tag: 'education',
  },
  {
    id: 5340,
    quote:
      'The aim of education should be to convert the mind into a living fountain, and not a reservoir. That which is filled by merely pumping in, will be emptied by pumping out.',
    author: 'John M. Mason',
    tag: 'education',
  },
  {
    id: 9290,
    quote: 'People, in teaching others, learn themselves.',
    author: 'Thomas Lodge',
    tag: 'education',
  },
  {
    id: 8836,
    quote:
      'Education is no longer thought of as a preparation for adult life, but as a continuing process of growth and development from birth until death.',
    author: 'Stephen Mitchell',
    tag: 'education',
  },
  {
    id: 10038,
    quote:
      'Being educated means to prefer the best not only to the worst but to the second best.',
    author: 'William Lyon Phelps',
    tag: 'education',
  },
  {
    id: 8158,
    quote:
      'My idea of education is to unsettle the minds of the young and inflame their intellects.',
    author: 'Robert Maynard Hutchins',
    tag: 'education',
  },
  {
    id: 5129,
    quote:
      'Higher education must lead the march back to the fundamentals of human relationships, to the old discovery that is ever new, that people do not live by bread alone.',
    author: 'John A. Hannah',
    tag: 'education',
  },
  {
    id: 7504,
    quote:
      'The direction in which education starts a person will determine their future life.',
    author: 'Plato',
    tag: 'education',
  },
  {
    id: 606,
    quote:
      'The person who knows not and knows that they know not is a child—teach them.',
    author: 'Arabian Proverb',
    tag: 'education',
  },
  {
    id: 174,
    quote:
      'Education is that which remains when one has forgotten everything they learned in school.',
    author: 'Albert Einstein',
    tag: 'education',
  },
  {
    id: 3942,
    quote:
      'A teacher affects eternity: they can never tell where their influence stops.',
    author: 'Henry Adams',
    tag: 'education',
  },
  {
    id: 10007,
    quote:
      'Let no youth have any anxiety about the upshot of their education, whatever the line of it may be. If one keeps faithfully busy each hour of the working-day, one may safely leave the result to itself.',
    author: 'William James',
    tag: 'education',
  },
  {
    id: 2517,
    quote:
      'Everyone who rises above the common level has received two educations: the first from their teachers; the second, more personal and important, from the self.',
    author: 'Edward Gibbon',
    tag: 'education',
  },
  {
    id: 6225,
    quote:
      'You should have education enough so that you won’t have to look up to people; and then more education so that you will be wise enough not to look down on people.',
    author: 'M.L. Boren',
    tag: 'education',
  },
  {
    id: 2145,
    quote:
      'Nature and education are somewhat similar. The latter transforms man, and in so doing creates a second nature.',
    author: 'Democritus',
    tag: 'education',
  },
  {
    id: 4744,
    quote:
      'Education today, more than ever before, must see clearly the dual objectives: Educating for living and educating for making a living.',
    author: 'James Mason Wood',
    tag: 'education',
  },
  {
    id: 8043,
    quote:
      'Education is the ability to listen to almost anything without losing your temper or your self-confidence.',
    author: 'Robert Frost',
    tag: 'education',
  },
  {
    id: 7776,
    quote:
      'The things taught in schools and colleges are not an education, but the means of education.',
    author: 'Ralph Waldo Emerson',
    tag: 'education',
  },
  {
    id: 6562,
    quote:
      'Training is everything. The peach was once a bitter almond; the cauliflower is nothing but cabbage with a college education.',
    author: 'Mark Twain',
    tag: 'education',
  },
  {
    id: 9675,
    quote: 'An educated individual is one on whom nothing is lost.',
    author: 'Wendell Smith',
    tag: 'education',
  },
  {
    id: 8615,
    quote:
      'The time may be coming when we will have to start accepting the idea that education is life, not merely a preparation for it.',
    author: 'Seymour E. Harris',
    tag: 'education',
  },
  {
    id: 9677,
    quote: 'Education is the mother of leadership.',
    author: 'Wendell Willkie',
    tag: 'education',
  },
  {
    id: 4639,
    quote:
      "The test and the use of one's education is that one finds pleasure in the exercise of one's mind.",
    author: 'Jacques Barzun',
    tag: 'education',
  },
  {
    id: 8118,
    quote:
      'The quality of a university is measured more by the kind of student it turns out than the kind it takes in.',
    author: 'Robert Kibbee',
    tag: 'education',
  },
  {
    id: 1490,
    quote:
      'Examinations are formidable even to the best prepared, for the greatest fool may ask more than the wisest can answer.',
    author: 'Charles Caleb Colton',
    tag: 'education',
  },
  {
    id: 10148,
    quote: 'The noblest exercise of the mind within doors ... is study.',
    author: 'William Ramsey',
    tag: 'education',
  },
  {
    id: 4462,
    quote:
      'To find out what we presently are and where we are going, we must know what we have been and what others have done; and this is the great purpose of humanistic scholarship.',
    author: 'Howard Mumford Jones',
    tag: 'education',
  },
  {
    id: 10087,
    quote:
      'The most important aspect of freedom of speech is freedom to learn. All education is a continuous dialogue—questions and answer that pursue every problem to the horizon.',
    author: 'William O. Douglas',
    tag: 'education',
  },
  {
    id: 9701,
    quote:
      'Sixty years ago I knew everything; now I know nothing; education is a progressive discovery of our own ignorance.',
    author: 'Will Durant',
    tag: 'education',
  },
  {
    id: 2494,
    quote:
      "An important personal quality for a teacher is that they care about humanity. If they don't, they are taking their pay illegally.",
    author: 'Edward C. Helwick',
    tag: 'education',
  },
  {
    id: 10593,
    quote:
      "If one cannot state a matter clearly enough so that even an intelligent twelve-year-old can understand it, one should remain within the cloistered walls of the university and laboratory until one gets a better grasp of one's subject matter.",
    author: 'Margaret Mead',
    tag: 'education',
  },
  {
    id: 2423,
    quote: 'Education is the chief defense of nations.',
    author: 'Edmund Burke',
    tag: 'education',
  },
  {
    id: 5447,
    quote:
      'The training which makes people happiest in themselves also makes them most serviceable to others.',
    author: 'John Ruskin',
    tag: 'education',
  },
  {
    id: 1406,
    quote:
      'One looks back with appreciation to the brilliant teachers, but with gratitude to those who touch our human feelings.',
    author: 'Carl Jung',
    tag: 'education',
  },
  {
    id: 2267,
    quote:
      "Education is the process by which individuals relate to the universe, give themselves citizenship in the changing world, share humanity's mind, and enfranchise their own souls.",
    author: 'Dr. John H. Finley',
    tag: 'education',
  },
  {
    id: 8556,
    quote: 'My joy in learning is partly that it enables me to teach.',
    author: 'Seneca',
    tag: 'education',
  },
  {
    id: 4321,
    quote: 'The great aim of education is not knowledge but action.',
    author: 'Herbert Spencer',
    tag: 'education',
  },
  {
    id: 8199,
    quote:
      'The peculiar fascination which the speeding train has for us comes from the evident progress it is making toward its definite goal ahead.',
    author: 'Roderick Stevens',
    tag: 'goals',
  },
  {
    id: 5063,
    quote: 'Those who move not forward go backward.',
    author: 'Johann Wolfgang Von Goethe',
    tag: 'goals',
  },
  {
    id: 4623,
    quote:
      'The successful person lengthens their stride when they discover that the signpost has deceived them; the failure looks for a place to sit down.',
    author: 'J.R. Rogers',
    tag: 'goals',
  },
  {
    id: 7999,
    quote: "A person's reach should exceed their grasp, or what’s heaven for?",
    author: 'Robert Browning',
    tag: 'goals',
  },
  {
    id: 7797,
    quote:
      'Hitch your wagon to a star. Let us not dwell on paltry works which serve our pot and bag alone.',
    author: 'Ralph Waldo Emerson',
    tag: 'goals',
  },
  {
    id: 6661,
    quote: 'To get anywhere, strike out for somewhere, or you’ll get nowhere.',
    author: 'Martha Lupton',
    tag: 'goals',
  },
  {
    id: 8941,
    quote: 'Unless you know where you are going, and road will take you there.',
    author: 'Theodore Levitt',
    tag: 'goals',
  },
  {
    id: 3531,
    quote:
      'In this life we get only those things for which we hunt, for which we strive, and for which we are willing to sacrifice.',
    author: 'George Matthew Adams',
    tag: 'goals',
  },
  {
    id: 3181,
    quote:
      'Many are stubborn in pursuit of the path they have chosen, few in pursuit of the goal.',
    author: 'Friedrich Wilhelm Nietzsche',
    tag: 'goals',
  },
  {
    id: 10266,
    quote: 'Not doing more than the average is what keeps the average down.',
    author: 'William Winans',
    tag: 'goals',
  },
  {
    id: 6018,
    quote:
      'There are two things to aim at in life: first, to get what you want; and, after that, to enjoy it. Only the wisest of people achieve the second.',
    author: 'Logan Pearsall Smith',
    tag: 'goals',
  },
  {
    id: 8134,
    quote: 'An aim in life is the only fortune worth the finding.',
    author: 'Robert Louis Stevenson',
    tag: 'goals',
  },
  {
    id: 53,
    quote:
      'Determine that the thing can and shall be done, and then we shall find the way.',
    author: 'Abraham Lincoln',
    tag: 'goals',
  },
  {
    id: 7568,
    quote:
      'Some people give up their designs when they have almost reached the goal; while others, on the contrary, obtain a victory by exerting, at the last moment, more vigorous efforts than before.',
    author: 'Polybius',
    tag: 'goals',
  },
  {
    id: 1894,
    quote:
      'You can’t just go on being a good egg. You must either hatch or go bad!',
    author: 'Clive Staples Lewis',
    tag: 'goals',
  },
  {
    id: 3714,
    quote:
      'Make the most of today. Translate your good intentions into actual deeds.  Realize that work well and worthily done makes life truly worth living.',
    author: 'Grenville Kleiser',
    tag: 'goals',
  },
  {
    id: 1808,
    quote:
      'If you aspire to the highest place it is no disgrace to stop at the second, or even the third.',
    author: 'Cicero',
    tag: 'goals',
  },
  {
    id: 6156,
    quote:
      'Far away there in the sunshine are my highest aspirations. I may not reach them, but I can look up and see their beauty, believe in them and try to follow where they lead.',
    author: 'Louisa May Alcott',
    tag: 'goals',
  },
  {
    id: 4761,
    quote:
      'Truly there is a tide in the affairs of people; but there is no gulf-stream setting forever in one direction.',
    author: 'James Russell Lowell',
    tag: 'goals',
  },
  {
    id: 4222,
    quote:
      'By every part of our nature we clasp things above us, one after another, not for the sake of remaining where we take hold, but that we may go higher.',
    author: 'Henry Ward Beecher',
    tag: 'goals',
  },
  {
    id: 4158,
    quote:
      'And in navigation, the more sights we take, the more likely we are to hit port.',
    author: 'Henry Osborn',
    tag: 'goals',
  },
  {
    id: 5064,
    quote:
      'Whatever you can do, or dream you can...begin it. Boldness has genius, power and magic in it.',
    author: 'Johann Wolfgang Von Goethe',
    tag: 'goals',
  },
  {
    id: 3685,
    quote:
      'If you wish to travel far and fast, travel light. Take off all your envies, jealousies, unforgiveness, selfishness and fears.',
    author: 'Glenn Clark',
    tag: 'goals',
  },
  {
    id: 3993,
    quote:
      'In the long run you hit only what you aim at. Therefore, though you should fail immediately, you had better aim at something high.',
    author: 'Henry David Thoreau',
    tag: 'goals',
  },
  {
    id: 3851,
    quote: 'Today’s put-off objectives reduce tomorrow’s achievements.',
    author: 'Harry F. Banks',
    tag: 'goals',
  },
  {
    id: 2236,
    quote:
      'When you determine what you want, you have made the most important decision of your life. You have to know what you want in order to attain it.',
    author: 'Douglas Lurton',
    tag: 'goals',
  },
  {
    id: 8233,
    quote:
      'Few can define their goal, much less write it. You cannot find happiness until your goal is clear and in view.',
    author: 'Ross Byron',
    tag: 'goals',
  },
  {
    id: 5286,
    quote:
      'Discover what you want most of all in this world, and set yourself to work on it.',
    author: 'John Homer Miller',
    tag: 'goals',
  },
  {
    id: 595,
    quote:
      'If you cry "Forward" you must without fail make plain in what direction to go.',
    author: 'Anton Chekhov',
    tag: 'goals',
  },
  {
    id: 5870,
    quote: 'The journey of a thousand miles begins with one step.',
    author: 'Lao-tzu',
    tag: 'goals',
  },
  {
    id: 8200,
    quote:
      'Every individual should have a purpose in life which is worthy of intense effort--and constantly work toward the definite goal ahead.',
    author: 'Roderick Stevens',
    tag: 'goals',
  },
  {
    id: 9184,
    quote:
      "The rung of a ladder was never meant to rest upon, but only to hold a person's foot long enough to enable them to put the other somewhat higher.",
    author: 'Thomas Huxley',
    tag: 'goals',
  },
  {
    id: 6436,
    quote: 'When you catch what you’re after, it’s gone.',
    author: 'Malcolm Forbes',
    tag: 'goals',
  },
  {
    id: 7076,
    quote: 'No one rises so high as they who knows not whither they are going.',
    author: 'Oliver Cromwell',
    tag: 'goals',
  },
  {
    id: 4882,
    quote:
      'Take the course opposite to custom and you will almost always do well.',
    author: 'Jean Jacques Rousseau',
    tag: 'goals',
  },
  {
    id: 6329,
    quote: 'If you don’t know what you want to do, it’s harder to do it.',
    author: 'Malcolm Forbes',
    tag: 'goals',
  },
  {
    id: 3094,
    quote:
      'Being easy-going when you have a goal to reach seldom makes the going easy.',
    author: 'Frank Tyger',
    tag: 'goals',
  },
  {
    id: 9533,
    quote:
      'Life has no smooth road for any of us; and in the bracing atmosphere of a high aim the very roughness stimulates the climber to steadier steps, till the legend, over steep ways to the stars, fulfills itself.',
    author: 'W.C. Doane',
    tag: 'goals',
  },
  {
    id: 284,
    quote:
      'The great person is the person who does a thing for the first time.',
    author: 'Alexander Smith',
    tag: 'greatness',
  },
  {
    id: 5778,
    quote:
      'Those who cannot feel the littleness of great things in themselves are apt to overlook the greatness of little things in others.',
    author: 'Kakuzo Okakura',
    tag: 'greatness',
  },
  {
    id: 707,
    quote:
      'It doesn’t take great people to do things, but it is doing things that makes a person great.',
    author: 'Arnold Glasow',
    tag: 'greatness',
  },
  {
    id: 10327,
    quote: 'The price of greatness is responsibility.',
    author: 'Winston Churchill',
    tag: 'greatness',
  },
  {
    id: 6164,
    quote:
      'Great people undertake great things because they are great; fools, because they think them easy.',
    author: 'Luc de Vauvenargues',
    tag: 'greatness',
  },
  {
    id: 4884,
    quote:
      'Great people never make bad use of their superiority; they see it, and feel it, and are not less modest. The more they have, the more they know their own deficiencies.',
    author: 'Jean Jacques Rousseau',
    tag: 'greatness',
  },
  {
    id: 1599,
    quote: 'The best teachers of humanity are the lives of great people.',
    author: 'Charles H. Fowler',
    tag: 'greatness',
  },
  {
    id: 7405,
    quote:
      'Do little things now; so shall big things come to thee by and by asking to be done.',
    author: 'Persian Proverb',
    tag: 'greatness',
  },
  {
    id: 3048,
    quote: 'I go to seek a great perhaps.',
    author: 'François Rabelais',
    tag: 'greatness',
  },
  {
    id: 6972,
    quote:
      'Every individual has a place to fill in the world, and is important in some respect, whether they choose to be so or not.',
    author: 'Nathaniel Hawthorne',
    tag: 'greatness',
  },
  {
    id: 430,
    quote:
      'To accomplish great things, we must not only act, but also dream, not only plan, but also believe.',
    author: 'Anatole France',
    tag: 'greatness',
  },
  {
    id: 3757,
    quote:
      'When an individual realizes their littleness, their greatness can appear.',
    author: 'H.G. Wells',
    tag: 'greatness',
  },
  {
    id: 2995,
    quote:
      'Those who give too much attention to trifling things become generally incapable of great ones.',
    author: 'François de La Rochefoucauld',
    tag: 'greatness',
  },
  {
    id: 2073,
    quote: 'From the little spark may burst a mighty flame.',
    author: 'Dante',
    tag: 'greatness',
  },
  {
    id: 8572,
    quote:
      'The greatest individual is one who chooses right with the most invincible resolution, who resists to sorest temptation from within and without, who bears the heaviest burdens cheerfully, and who is calmest in storms.',
    author: 'Seneca',
    tag: 'greatness',
  },
  {
    id: 4432,
    quote:
      'If any individual seeks for greatness, let them forget greatness and ask for truth, and they will find both.',
    author: 'Horace Mann',
    tag: 'greatness',
  },
  {
    id: 7800,
    quote:
      'Great individuals are more distinguished by range and extent than by originality.',
    author: 'Ralph Waldo Emerson',
    tag: 'greatness',
  },
  {
    id: 8322,
    quote:
      'To do great work an individual must be very idle as well as very industrious.',
    author: 'Samuel Butler',
    tag: 'greatness',
  },
  {
    id: 9793,
    quote: 'Difficulty is the nurse of greatness.',
    author: 'William Cullen Bryant',
    tag: 'greatness',
  },
  {
    id: 2249,
    quote:
      'Lack of something to feel important about is almost the greatest tragedy an individual may have.',
    author: 'Dr. Arthur E. Morgan',
    tag: 'greatness',
  },
  {
    id: 3311,
    quote:
      'All people who are really great can afford to be really human and to be shown so.',
    author: 'Gamaliel Bradford',
    tag: 'greatness',
  },
  {
    id: 4181,
    quote:
      'Lives of great individuals all remind us we can make our lives sublime!',
    author: 'Henry Wadsworth Longfellow',
    tag: 'greatness',
  },
  {
    id: 1718,
    quote: 'Great people never feel great; small people never feel small.',
    author: 'Chinese Proverb',
    tag: 'greatness',
  },
  {
    id: 8495,
    quote:
      'The career of a great person remains an enduring monument of human energy. The individual dies and disappears, but their thoughts and acts survive and leave an indelible stamp upon humanity.',
    author: 'Samuel Smiles',
    tag: 'greatness',
  },
  {
    id: 9064,
    quote: 'All greatness is unconscious, or it is little and naught.',
    author: 'Thomas Carlyle',
    tag: 'greatness',
  },
  {
    id: 2907,
    quote: 'All rising to a great place is by a winding stair.',
    author: 'Francis Bacon',
    tag: 'greatness',
  },
  {
    id: 2621,
    quote:
      'A great individual leaves clean work behind them, and requires no sweeper up of the chips.',
    author: 'Elizabeth Barrett Browning',
    tag: 'greatness',
  },
  {
    id: 4728,
    quote: 'Great thoughts, like great deeds, need no trumpet.',
    author: 'James M. Bailey',
    tag: 'greatness',
  },
  {
    id: 1664,
    quote:
      'Life is made up of little things. It is very rarely that an occasion is offered for doing a great deal at once. True greatness consists in being great in little things.',
    author: 'Charles Simmons',
    tag: 'greatness',
  },
  {
    id: 1079,
    quote:
      'It is a great mistake to think of being great without goodness; and I pronounce it as certain that there was never yet a truly great individual that was not at the same time truly virtuous.',
    author: 'Benjamin Franklin',
    tag: 'greatness',
  },
  {
    id: 1921,
    quote:
      'There are three marks of a superior individual: being virtuous, they are free from anxiety; being wise, they are free from perplexity; being brave, they are free from fear.',
    author: 'Confucius',
    tag: 'greatness',
  },
  {
    id: 7263,
    quote:
      'A really great individual is known by three signs-generosity in the design, humanity in the execution, moderation in success.',
    author: 'Otto von Bismarck',
    tag: 'greatness',
  },
  {
    id: 5979,
    quote:
      'There is no right without a parallel duty, no liberty without the supremacy of the law, no high destiny without earnest perseverance, no greatness without self-denial.',
    author: 'Lieber',
    tag: 'greatness',
  },
  {
    id: 4136,
    quote: 'A great individual is one who can have power and not abuse it.',
    author: 'Henry L. Doherty',
    tag: 'greatness',
  },
  {
    id: 7801,
    quote:
      'The great individual is not convulsible or tormentable; events pass over them without much impression.',
    author: 'Ralph Waldo Emerson',
    tag: 'greatness',
  },
  {
    id: 5765,
    quote:
      'The truly great individual is one who would master no one, and who would be mastered by none.',
    author: 'Kahlil Gibran',
    tag: 'greatness',
  },
  {
    id: 7820,
    quote:
      'In every individual there is something wherein I may learn of them, and in that I am their pupil.',
    author: 'Ralph Waldo Emerson',
    tag: 'learning',
  },
  {
    id: 2026,
    quote:
      'To think of learning as a preparation for something beyond learning is a defeat of the process. The most important attitude that can be formed is that of desire to go on learning.',
    author: 'Daniel Bell',
    tag: 'learning',
  },
  {
    id: 5263,
    quote:
      'We have an infinite amount to learn both from nature and from each other.',
    author: 'John Glenn',
    tag: 'learning',
  },
  {
    id: 612,
    quote: 'Learning is a treasury whose keys are queries.',
    author: 'Arabian Proverb',
    tag: 'learning',
  },
  {
    id: 3121,
    quote:
      'I find that a great part of the information I have was acquired by looking up something and finding something else on the way.',
    author: 'Franklin P. Adams',
    tag: 'learning',
  },
  {
    id: 5646,
    quote:
      'There is no easy method of learning difficult things. The method is to close the door, pretend that you are not at home, and work.',
    author: 'Joseph de Maistre',
    tag: 'learning',
  },
  {
    id: 1924,
    quote:
      'One who learns but does not think is lost, one who thinks but does not learn is in danger.',
    author: 'Confucius',
    tag: 'learning',
  },
  {
    id: 3818,
    quote:
      'Our task as we grow older in a rapidly advancing science, is to retain the capacity of joy in discoveries which correct older ideas, and to learn from our pupils as we teach them.',
    author: 'Hans Zinsser',
    tag: 'learning',
  },
  {
    id: 7975,
    quote:
      'To stay young requires unceasing cultivation of the ability to unlearn hoods.',
    author: 'Robert A. Heinlein',
    tag: 'learning',
  },
  {
    id: 3494,
    quote: 'The love of learning and the love of money rarely meet.',
    author: 'George Herbert',
    tag: 'learning',
  },
  {
    id: 2100,
    quote:
      'The sweetest and most inoffensive path of life leads through the avenues of science and learning; and whoever can either remove any obstruction in this way ought to be esteemed a benefactor to humanity.',
    author: 'David Hume',
    tag: 'learning',
  },
  {
    id: 9983,
    quote:
      'If you want to earn more-—earn more. If you want to get more out of the world you must put more into the world. For, after all, people will get no more out of life than they put into it.',
    author: 'William J.H. Boetcker',
    tag: 'learning',
  },
  {
    id: 7406,
    quote:
      'One pound of learning requires ten pounds of commonsense to apply it.',
    author: 'Persian Proverb',
    tag: 'learning',
  },
  {
    id: 4154,
    quote:
      'In this age, which believes that there is a shortcut to everything, the greatest lesson to be learned is that the most difficult way is, in the long run, the easiest.',
    author: 'Henry Miller',
    tag: 'learning',
  },
  {
    id: 3098,
    quote: 'Learning is either a continuing thing or it is nothing.',
    author: 'Frank Tyger',
    tag: 'learning',
  },
  {
    id: 251,
    quote: 'A great mind can lead and be led.',
    author: 'Alexander Cannon',
    tag: 'mind',
  },
  {
    id: 419,
    quote:
      "An individual's felicity consists not in the outward and visible blessing of fortune, but in the inward and unseen perfections and riches of the mind.",
    author: 'Anacharsis',
    tag: 'mind',
  },
  {
    id: 202,
    quote:
      'The mind is like the stomach. It is not how much you put into it that counts, but how much it digests.',
    author: 'Albert J. Nock',
    tag: 'mind',
  },
  {
    id: 8144,
    quote:
      'Quiet minds cannot be perplexed or frightened but go on in fortune or misfortune at their own private pace, like a clock during a thunderstorm.',
    author: 'Robert Louis Stevenson',
    tag: 'mind',
  },
  {
    id: 7830,
    quote: 'Nothing is at last sacred but the integrity of your own mind.',
    author: 'Ralph Waldo Emerson',
    tag: 'mind',
  },
  {
    id: 7357,
    quote:
      'The mind has transformed the world, and the world is repaying it with interest. It has led humankind where he had no idea how to go.',
    author: 'Paul Valery',
    tag: 'mind',
  },
  {
    id: 1580,
    quote:
      'There will always be a frontier where there is an open mind and a willing hand.',
    author: 'Charles F. Kettering',
    tag: 'mind',
  },
  {
    id: 3814,
    quote: 'Only in a quiet mind is adequate perception of the world.',
    author: 'Hans Margolius',
    tag: 'mind',
  },
  {
    id: 7668,
    quote:
      'Our minds are like our stomachs; they are whetted by the change of their food, and variety supplies both with fresh appetite.',
    author: 'Quintilian',
    tag: 'mind',
  },
  {
    id: 7426,
    quote: 'The mind longs for what it has missed.',
    author: 'Petronius Arbiter',
    tag: 'mind',
  },
  {
    id: 9935,
    quote: 'A great mind is one that can forget or look beyond itself.',
    author: 'William Hazlitt',
    tag: 'mind',
  },
  {
    id: 2924,
    quote: 'Much bending breaks the bow; much unbending the mind.',
    author: 'Francis Bacon',
    tag: 'mind',
  },
  {
    id: 3497,
    quote: 'The resolved mind hath no cares.',
    author: 'George Herbert',
    tag: 'mind',
  },
  {
    id: 10333,
    quote: 'The empires of the future are the empires of the mind.',
    author: 'Winston Churchill',
    tag: 'mind',
  },
  {
    id: 2122,
    quote:
      'Anything that the human mind can conceive can be produced ultimately.',
    author: 'David Sarnoff',
    tag: 'mind',
  },
  {
    id: 2513,
    quote: 'A mind once cultivated will not lie fallow for half an hour.',
    author: 'Edward Bulwer-Lytton',
    tag: 'mind',
  },
  {
    id: 7382,
    quote:
      'I don’t wait for moods. You accomplish nothing if you do that. Your mind must know it has got to get down to earth.',
    author: 'Pearl S. Buck',
    tag: 'mind',
  },
  {
    id: 3594,
    quote:
      'A vacant mind invites dangerous inmates, as a deserted mansion tempts wandering outcasts to enter and take up their abode in its desolate apartments.',
    author: 'George Stillman Hilliard',
    tag: 'mind',
  },
  {
    id: 7537,
    quote:
      "The great business of life is to improve one's mind, and govern one's manners; all other projects and pursuits, whether in our power to compass or not, are only amusements.",
    author: 'Pliny',
    tag: 'mind',
  },
  {
    id: 9589,
    quote: 'What impresses people is not mind, but the result of mind.',
    author: 'Walter Bagehot',
    tag: 'mind',
  },
  {
    id: 3355,
    quote:
      'You cannot fathom your mind.... The more you draw from it, the more clear and fruitful it will be.',
    author: 'George A. Sala',
    tag: 'mind',
  },
  {
    id: 8432,
    quote:
      'A truly strong and sound mind is the mind that can equally embrace great things and small.',
    author: 'Samuel Johnson',
    tag: 'mind',
  },
  {
    id: 2530,
    quote:
      'The only person who can’t change their mind is a person who hasn’t got one.',
    author: 'Edward Noyes Wescott',
    tag: 'mind',
  },
  {
    id: 156,
    quote: 'The mind’s the standard of the individual.',
    author: 'Alan Watts',
    tag: 'mind',
  },
  {
    id: 8623,
    quote:
      'The whole object of education is, or should be, to develop mind.  The mind should be able to pass judgment on events as they arise, make decisions.',
    author: 'Sherwood Anderson',
    tag: 'mind',
  },
  {
    id: 2060,
    quote:
      'The mind is the great lever of all things; human thought is the process by which human ends are answered.',
    author: 'Daniel Webster',
    tag: 'mind',
  },
  {
    id: 7516,
    quote:
      'If a person be endowed with a generous mind, this is the best kind of nobility.',
    author: 'Plato',
    tag: 'mind',
  },
  {
    id: 7829,
    quote:
      'A chief event of life is the day in which we have encountered a mind that startled us.',
    author: 'Ralph Waldo Emerson',
    tag: 'mind',
  },
  {
    id: 9652,
    quote: 'Great minds have purposes, others have wishes.',
    author: 'Washington Irving',
    tag: 'mind',
  },
  {
    id: 3536,
    quote:
      'The more the mind is used the more flexible it becomes, and the more it takes upon itself new interests.',
    author: 'George Matthew Adams',
    tag: 'mind',
  },
  {
    id: 9391,
    quote:
      'There is nothing so elastic as the human mind. The more we are obliged to do, the more we are able to accomplish.',
    author: 'Tryon Edwards',
    tag: 'mind',
  },
  {
    id: 1767,
    quote: 'Few minds wear out; more rust out.',
    author: 'Christian Bovée',
    tag: 'mind',
  },
  {
    id: 3277,
    quote:
      'Merely having an open mind is nothing. The object of opening the mind, as of opening the mouth, is to shut it again on something solid.',
    author: 'G.K. Chesterton',
    tag: 'mind',
  },
  {
    id: 10295,
    quote:
      'Not the state of the body but the state of the mind and soul is the measure of the wellbeing of each of us.',
    author: 'Winfred Rhoades',
    tag: 'mind',
  },
  {
    id: 1826,
    quote:
      'The proof of a well-trained mind is that it rejoices in which is good and grieves at the opposite.',
    author: 'Cicero',
    tag: 'mind',
  },
  {
    id: 6110,
    quote: 'Minds are like parachutes—they only function when open.',
    author: 'Lord Thomas Dewar',
    tag: 'mind',
  },
  {
    id: 10215,
    quote: 'It is the mind that makes the body rich.',
    author: 'William Shakespeare',
    tag: 'mind',
  },
  {
    id: 5617,
    quote:
      'One of the most important but one of the most difficult things for a powerful mind is to be its own master.',
    author: 'Joseph Addison',
    tag: 'mind',
  },
  {
    id: 9818,
    quote:
      'It is the mind which does the work of the world, so that the more there is of mind, the more work will be accomplished.',
    author: 'William Ellery Channing',
    tag: 'mind',
  },
  {
    id: 6209,
    quote:
      'It is well for people who think to change their minds occasionally in order to keep them clean.',
    author: 'Luther Burbank',
    tag: 'mind',
  },
  {
    id: 7556,
    quote: 'The richest soil, if uncultivated, produces the rankest weeds.',
    author: 'Plutarch',
    tag: 'mind',
  },
  {
    id: 5950,
    quote:
      'Iron rusts from disuse, stagnant water loses its purity and in cold weather becomes frozen; even so does inaction sap the vigors of the mind.',
    author: 'Leonardo da Vinci',
    tag: 'mind',
  },
  {
    id: 8589,
    quote: 'A good mind rules a kingdom.',
    author: 'Seneca',
    tag: 'mind',
  },
  {
    id: 208,
    quote: 'For me, hard work represents the supreme luxury of life.',
    author: 'Albert M. Greenfield',
    tag: 'perserverence',
  },
  {
    id: 9272,
    quote:
      'When we see ourselves in a situation which must be endured and gone through, it is best to make up our minds to it, meet it with firmness, and accommodate everything to it in the best way practicable.',
    author: 'Thomas Jefferson',
    tag: 'perserverence',
  },
  {
    id: 9665,
    quote: 'Without perseverance talent is a barren bed.',
    author: 'Welsh Proverb',
    tag: 'perserverence',
  },
  {
    id: 4309,
    quote:
      'Failure is only postponed success as long as courage coaches ambition. The habit of persistence is the habit of victory.',
    author: 'Herbert Kaufman',
    tag: 'perserverence',
  },
  {
    id: 5092,
    quote:
      'Whatever necessity lays upon thee, endure; whatever she commands, do.',
    author: 'Johann Wolfgang Von Goethe',
    tag: 'perserverence',
  },
  {
    id: 5905,
    quote:
      'Tis known by the name of perseverance in a good cause, and obstinacy in a bad one.',
    author: 'Laurence Sterne',
    tag: 'perserverence',
  },
  {
    id: 5003,
    quote: 'Whoever perseveres will be crowned.',
    author: 'Johann Gottfried von Herder',
    tag: 'perserverence',
  },
  {
    id: 1039,
    quote:
      'I have brought myself by long meditation to the conviction that a human being with a settled purpose must accomplish it, and that nothing can resist a will which will stake even existence upon its fulfillment.',
    author: 'Benjamin Disraeli',
    tag: 'perserverence',
  },
  {
    id: 7894,
    quote: 'Press on. Nothing in the world can take the place of persistence.',
    author: 'Ray A. Kroc',
    tag: 'perserverence',
  },
  {
    id: 5621,
    quote:
      'Our delight in any particular study, art, or science rises in proportion to the application which we bestow upon it. Thus, what was at first an exercise becomes at length an entertainment.',
    author: 'Joseph Addison',
    tag: 'perserverence',
  },
  {
    id: 2113,
    quote: 'As long as the day lasts, let’s give it all we got.',
    author: 'David O. McKay',
    tag: 'perserverence',
  },
  {
    id: 2215,
    quote: 'Perseverance and audacity generally win.',
    author: 'Dorothée Luzy',
    tag: 'perserverence',
  },
  {
    id: 8443,
    quote: 'Great works are performed not by strength but by perseverance.',
    author: 'Samuel Johnson',
    tag: 'perserverence',
  },
  {
    id: 5851,
    quote:
      'Vacillating people seldom succeed. They seldom win the solid respect of their peers. Successful people are very careful in reaching decisions and very persistent and determined in action thereafter.',
    author: 'L.G. Elliott',
    tag: 'perserverence',
  },
  {
    id: 5919,
    quote: 'To live is not to learn, but to apply.',
    author: 'Legouvé',
    tag: 'perserverence',
  },
  {
    id: 5091,
    quote:
      'In the realm of ideas, everything depends on enthusiasm; in the real world, all rests on perseverance.',
    author: 'Johann Wolfgang Von Goethe',
    tag: 'perserverence',
  },
  {
    id: 5422,
    quote:
      'Courage and perseverance have a magical talisman, before which difficulties disappear and obstacles vanish into air.',
    author: 'John Quincy Adams',
    tag: 'perserverence',
  },
  {
    id: 8442,
    quote: 'Few things are impossible to diligence and skill.',
    author: 'Samuel Johnson',
    tag: 'perserverence',
  },
  {
    id: 6877,
    quote: 'Genius is perseverance in disguise.',
    author: 'Mike Newlin',
    tag: 'perserverence',
  },
  {
    id: 8090,
    quote:
      'Persistence is what makes the impossible possible, the possible likely, and the likely definite.',
    author: 'Robert Half',
    tag: 'perserverence',
  },
  {
    id: 6188,
    quote: 'Fate gave to humanity the courage of endurance.',
    author: 'Ludwig van Beethoven',
    tag: 'perserverence',
  },
  {
    id: 8444,
    quote:
      'All the performances of human art, at which we look with praise or wonder, are instances of the resistless force of perseverance.',
    author: 'Samuel Johnson',
    tag: 'perserverence',
  },
  {
    id: 893,
    quote:
      'How you start is important, very important, but in the end it is how you finish that counts. The victor in the race is not the one who dashes off swiftest but the one who leads at the finish.',
    author: 'B.C. Forbes',
    tag: 'perserverence',
  },
  {
    id: 8264,
    quote:
      'A determined soul will do more with a rusty monkey wrench than a loafer will accomplish with all the tools in a machine shop.',
    author: 'Rupert Hughes',
    tag: 'perserverence',
  },
  {
    id: 4586,
    quote: 'Perseverance is failing 19 times and succeeding the 20th.',
    author: 'J. Andrews',
    tag: 'perserverence',
  },
  {
    id: 3018,
    quote:
      'Few things are impracticable in themselves; and it is for want of application, rather than of means, that people fail of success.',
    author: 'François de La Rochefoucauld',
    tag: 'perserverence',
  },
  {
    id: 6868,
    quote:
      'Diligence is the mother of good fortune, and idleness, its opposite, never brought anyone to the goal of any of his best wishes.',
    author: 'Miguel de Cervantes',
    tag: 'perserverence',
  },
  {
    id: 619,
    quote: 'Diligence is the greatest of teachers.',
    author: 'Arabian Proverb',
    tag: 'perserverence',
  },
  {
    id: 1606,
    quote: 'By perseverance the snail reached the ark.',
    author: 'Charles H. Spurgeon',
    tag: 'perserverence',
  },
  {
    id: 583,
    quote: 'Everything yields to diligence.',
    author: 'Antiphanes',
    tag: 'perserverence',
  },
  {
    id: 1931,
    quote:
      'The expectations of life depend upon diligence; the mechanic that would perfect his work must first sharpen his tools.',
    author: 'Confucius',
    tag: 'perserverence',
  },
  {
    id: 10335,
    quote:
      'This is no time for ease and comfort. It is the time to dare and endure.',
    author: 'Winston Churchill',
    tag: 'perserverence',
  },
  {
    id: 9874,
    quote:
      'A determination to succeed is the only way to succeed that I know anything about.',
    author: 'William Feather',
    tag: 'perserverence',
  },
  {
    id: 4248,
    quote:
      'Vigilance is not only the price of liberty, but of success of any sort.',
    author: 'Henry Ward Beecher',
    tag: 'perserverence',
  },
  {
    id: 4987,
    quote:
      'You may be whatever you resolve to be. Determine to be something in the world, and you will be something. I cannot, never accomplished anything: I will try, has wrought wonders.',
    author: 'Joel Hawes',
    tag: 'perserverence',
  },
  {
    id: 1285,
    quote: 'An ounce of application is worth a ton of abstraction.',
    author: 'Booker T. Washington',
    tag: 'perserverence',
  },
  {
    id: 1832,
    quote:
      'Diligence, as it avails in all things, is also of the utmost moment in pleading causes. Diligence is to be particularly cultivated by us; it is to be constantly exerted, it is capable of effecting almost everything.',
    author: 'Cicero',
    tag: 'perserverence',
  },
  {
    id: 963,
    quote:
      'Mediocrity obtains more with application than superiority without it.',
    author: 'Baltasar Gracian',
    tag: 'perserverence',
  },
  {
    id: 9453,
    quote:
      'Individual commitment to a group effort—that is what makes a team work, a company work, a society work, a civilization work.',
    author: 'Vince Lombardi',
    tag: 'perserverence',
  },
  {
    id: 1582,
    quote:
      'Keep on going, and the chances are that you will stumble on something, perhaps when you are least expecting it. I never heard of anyone ever stumbling on something sitting down.',
    author: 'Charles F. Kettering',
    tag: 'perserverence',
  },
  {
    id: 2573,
    quote:
      'Even in social life, it is persistency which attracts confidence more than talents and accomplishments.',
    author: 'Edwin P. Whipple',
    tag: 'perserverence',
  },
  {
    id: 223,
    quote:
      'Anyone who proposes to do good must not expect people to roll stones out of their way, but must accept their lot calmly if they even roll a few more on it.',
    author: 'Albert Schweitzer',
    tag: 'strength',
  },
  {
    id: 721,
    quote: 'Only a strong tree can stand alone.',
    author: 'Arnold Glasow',
    tag: 'strength',
  },
  {
    id: 10280,
    quote:
      'Live in terms of your strong points. Magnify them. Let your weaknesses shrivel up and die from lack of nourishment.',
    author: 'William Young Elliot',
    tag: 'strength',
  },
  {
    id: 516,
    quote:
      'Strength alone knows conflict; weakness is below even defeat, and is born vanquished.',
    author: 'Anne Swetchine',
    tag: 'strength',
  },
  {
    id: 6485,
    quote:
      'Look well into thyself; there is a source of strength which will always spring up if thou wilt always look there.',
    author: 'Marcus Aurelius Antoninus',
    tag: 'strength',
  },
  {
    id: 6388,
    quote:
      'The difference between towering and cowering is totally a matter of inner posture.',
    author: 'Malcolm Forbes',
    tag: 'strength',
  },
  {
    id: 1750,
    quote:
      'In the assurance of strength there is strength; and they are the weakest, however strong, who have no faith in themselves or their powers.',
    author: 'Christian Bovée',
    tag: 'strength',
  },
  {
    id: 3154,
    quote:
      'A living being seeks, above all, to discharge its strength. Life is will to power.',
    author: 'Friedrich Wilhelm Nietzsche',
    tag: 'strength',
  },
  {
    id: 9094,
    quote:
      'The block of granite which is an obstacle in the pathway of the weak becomes a stepping-stone in the pathway of the strong.',
    author: 'Thomas Carlyle',
    tag: 'strength',
  },
  {
    id: 5585,
    quote:
      'Although people are accused of not knowing their own weakness, yet perhaps few know their own strength. It is in people as in soils, where sometimes there is a vein of gold which the owner knows not of.',
    author: 'Jonathan Swift',
    tag: 'strength',
  },
  {
    id: 8791,
    quote:
      'At times to think of one’s outer helplessness is good, but to think always of one’s inner strength is infinitely better.',
    author: 'Sri Chinmoy',
    tag: 'strength',
  },
  {
    id: 4771,
    quote:
      'That cause is strong which has, not a multitude, but one strong person behind it.',
    author: 'James Russell Lowell',
    tag: 'strength',
  },
  {
    id: 88,
    quote: 'I will study and get ready and someday my chance will come.',
    author: 'Abraham Lincoln',
    tag: 'study',
  },
  {
    id: 476,
    quote:
      'Concentration is my motto—first honesty, then industry, then concentration.',
    author: 'Andrew Carnegie',
    tag: 'study',
  },
  {
    id: 9884,
    quote: 'Concentrate on your work and you will forget your other troubles.',
    author: 'William Feather',
    tag: 'study',
  },
  {
    id: 5104,
    quote:
      'The use of a thing is only a part of its significance. To know anything thoroughly, to have the full command of it in all its appliances, we must study it on its own account, independently of any special application.',
    author: 'Johann Wolfgang Von Goethe',
    tag: 'study',
  },
  {
    id: 2523,
    quote:
      'The love of study, a passion which derives fresh vigor from enjoyment, supplies each day and hour with a perpetual source of independent and rational pleasure.',
    author: 'Edward Gibbon',
    tag: 'study',
  },
  {
    id: 7497,
    quote:
      'Every noble acquisition is attended with its risks; An individual who fears to encounter the one must not expect to obtain the other.',
    author: 'Pietro Metastasio',
    tag: 'trying',
  },
  {
    id: 2124,
    quote:
      'Whatever course you have chosen for yourself, it will not be a chore but an adventure if you bring to it a sense of the glory of striving-if your sights are set far above the merely secure and mediocre.',
    author: 'David Sarnoff',
    tag: 'trying',
  },
  {
    id: 8007,
    quote:
      'Tis not what a person does which exalts them, but what a person would do!',
    author: 'Robert Browning',
    tag: 'trying',
  },
  {
    id: 4265,
    quote:
      'By every part of our nature we clasp things above us, one after another, not for the sake of remaining where we take hold, but that we may go higher.',
    author: 'Henry Ward Beecher',
    tag: 'trying',
  },
  {
    id: 3831,
    quote:
      'Striving for excellence motivates you; striving for perfection is demoralizing.',
    author: 'Harriet Braiker',
    tag: 'trying',
  },
  {
    id: 6395,
    quote: 'Venture nothing, and life is less than it should be.',
    author: 'Malcolm Forbes',
    tag: 'trying',
  },
  {
    id: 1737,
    quote: 'The journey of a thousand miles starts with a single step.',
    author: 'Chinese Proverb',
    tag: 'trying',
  },
  {
    id: 7370,
    quote: 'Trying is the touchstone to accomplishment.',
    author: 'Paul von Ringelheim',
    tag: 'trying',
  },
  {
    id: 7877,
    quote:
      'All life is an experiment. The more experiments you make the better.',
    author: 'Ralph Waldo Emerson',
    tag: 'trying',
  },
  {
    id: 8475,
    quote:
      'Nothing will ever be attempted, if all possible objections must first be overcome.',
    author: 'Samuel Johnson',
    tag: 'trying',
  },
  {
    id: 8767,
    quote:
      "During the first period of a one's life the greatest danger is: not to take the risk. When once the risk has really been taken, then the greatest danger is to risk too much.",
    author: 'Soren Kierkegaard',
    tag: 'trying',
  },
  {
    id: 4129,
    quote: 'Until you try, you don’t know what you can’t do.',
    author: 'Henry James',
    tag: 'trying',
  },
  {
    id: 196,
    quote:
      'There exists a passion for comprehension, just as there exists a passion for music.  Without this passion there would be neither mathematics nor natural science.',
    author: 'Albert Einstein',
    tag: 'understanding',
  },
  {
    id: 5333,
    quote: 'The great art of learning is to understand but little at a time.',
    author: 'John Locke',
    tag: 'understanding',
  },
  {
    id: 7703,
    quote:
      'Understanding comes through communication, and through understanding we find the way to peace.',
    author: 'Ralph C. Smedley',
    tag: 'understanding',
  },
  {
    id: 3667,
    quote: 'To understand and to be understood makes our happiness on earth.',
    author: 'German Proverb',
    tag: 'understanding',
  },
  {
    id: 2777,
    quote:
      'Thoughts are wonderful things, that they can bring two people, so far apart, into harmony and understanding for even a little while.',
    author: 'Ernest Pyle',
    tag: 'understanding',
  },
  {
    id: 1653,
    quote:
      'The great need today in every phase of our social, economical and political life is understanding. It has always been so, but today the need is even greater.',
    author: 'Charles R. Hook',
    tag: 'understanding',
  },
  {
    id: 2493,
    quote:
      'One who calls in the aid of an equal understanding doubles ones own.',
    author: 'Edward Burke',
    tag: 'understanding',
  },
  {
    id: 9633,
    quote:
      'If I am looking for intelligent and unselfish understanding of our problems, I shall seek it among the makers and builders with far more confidence than among the talkers and the manipulators.',
    author: 'Walter Teague',
    tag: 'understanding',
  },
  {
    id: 1738,
    quote:
      'Be not disturbed at being misunderstood; be disturbed rather at not being understanding.',
    author: 'Chinese Proverb',
    tag: 'understanding',
  },
  {
    id: 7960,
    quote:
      'I know no evil so great as the abuse of the understanding, and yet there is no one vice more common.',
    author: 'Richard Steele',
    tag: 'understanding',
  },
  {
    id: 1672,
    quote: 'When the heart is won, the understanding is easily convinced.',
    author: 'Charles Simmons',
    tag: 'understanding',
  },
  {
    id: 2938,
    quote:
      'The eye of the understanding is like the eye of the sense; for as you may see great objects through small crannies or holes, so you may see great axioms of nature through small and contemptible instances.',
    author: 'Francis Bacon',
    tag: 'understanding',
  },
  {
    id: 2118,
    quote:
      'Understanding is more comprehensive than intellect because it intuits truths that cautious intellect can get sight of but never embrace—like a sea-gazer who never plunges in.',
    author: 'David S. Jones',
    tag: 'understanding',
  },
  {
    id: 4040,
    quote:
      'Good for the body is the work of the body, good for the soul is the work of the soul, and good for either the work of the other.',
    author: 'Henry David Thoreau',
    tag: 'work',
  },
  {
    id: 4532,
    quote:
      'My grandfather once told me that there are two kinds of people: those who do the work and those who take the credit. He told me to try to be in the first group; there was much less competition there.',
    author: 'Indira Gandhi',
    tag: 'work',
  },
  {
    id: 4272,
    quote:
      'If we would have anything of benefit, we must earn it, and earning it become shrewd, inventive, ingenious, active, enterprising.',
    author: 'Henry Ward Beecher',
    tag: 'work',
  },
  {
    id: 7152,
    quote: 'A day’s impact is better than a month of dead pull.',
    author: 'Oliver Wendell Holmes',
    tag: 'work',
  },
  {
    id: 9892,
    quote: 'The right person can make a good job out of any job.',
    author: 'William Feather',
    tag: 'work',
  },
  {
    id: 7885,
    quote:
      'The sum of wisdom is that time is never lost that is devoted to work.',
    author: 'Ralph Waldo Emerson',
    tag: 'work',
  },
  {
    id: 10032,
    quote:
      'Nothing is so fatiguing as the eternal hanging on of an uncompleted task.',
    author: 'William James',
    tag: 'work',
  },
  {
    id: 2117,
    quote:
      'Whatever you do, if you do it hard enough you’ll enjoy it. The important thing is to work and work hard.',
    author: 'David Rockefeller',
    tag: 'work',
  },
  {
    id: 4115,
    quote:
      'People must work. That is certain as the sun. But they may work grudgingly or they may work gratefully; they may work as a people, or they may work as machines. There is no work so rude, that someone may not exalt it; no work so impassive, that someone may not breathe a soul into it; no work so dull that someone may not enliven it.',
    author: 'Henry Giles',
    tag: 'work',
  },
  {
    id: 1386,
    quote:
      'All growth depends upon activity. There is no development physically or intellectually without effort, and effort means work. Work is not a curse; it is the prerogative of intelligence, the only means to humanity, and the measure of civilization.',
    author: 'Calvin Coolidge',
    tag: 'work',
  },
  {
    id: 934,
    quote:
      'Whimpering never kept a leaking vessel from foundering. Vigorously manning the pumps has. Get busy with your head and hands, not your chin.',
    author: 'B.C. Forbes',
    tag: 'work',
  },
  {
    id: 4102,
    quote:
      'There are two ways of making yourself stand out from the crowd. One is by having a job so big you can go home before the bell rings if you want to. The other is by finding so much to do that you must stay after the others have gone. The one who enjoys the former once took advantage of the latter.',
    author: 'Henry Ford',
    tag: 'work',
  },
  {
    id: 5817,
    quote:
      'Work only a half a day. It makes no difference which half—the first 12 hours or the last 12 hours.',
    author: 'Kemmons Wilson',
    tag: 'work',
  },
  {
    id: 6757,
    quote:
      'No fine work can be done without concentration and self-sacrifice and toil and doubt.',
    author: 'Max Beerbohm',
    tag: 'work',
  },
  {
    id: 5473,
    quote:
      'The highest reward for a person’s toil is not what one gets for it, but what one becomes by it.',
    author: 'John Ruskin',
    tag: 'work',
  },
  {
    id: 5374,
    quote:
      'Let us go forth and resolutely dare with sweat of brow to toil our little day.',
    author: 'John Milton',
    tag: 'work',
  },
  {
    id: 9520,
    quote: 'Work is often the father of pleasure.',
    author: 'Voltaire',
    tag: 'work',
  },
  {
    id: 3143,
    quote:
      "If I were to suggest a general rule for happiness, I would say: 'Work a little harder; work a little longer; work!'",
    author: 'Frederick H. Ecker',
    tag: 'work',
  },
  {
    id: 4981,
    quote: 'The more I work, the more I want to work.',
    author: 'Joan Miro',
    tag: 'work',
  },
  {
    id: 567,
    quote: 'Doing nothing is the hardest work of all.',
    author: 'Anonymous',
    tag: 'work',
  },
  {
    id: 3873,
    quote:
      'Find something you love to do and you’ll never have to work a day in your life.',
    author: 'Harvey Mackay',
    tag: 'work',
  },
  {
    id: 1620,
    quote:
      'Being forced to work, and forced to do your best, will breed in you temperance and self-control, diligence and strength of will, cheerfulness and content, and a hundred virtues which the idle never know.',
    author: 'Charles Kingsley',
    tag: 'work',
  },
  {
    id: 4544,
    quote:
      'I never work hard when I am working; I only work hard when I am not working.',
    author: 'Irving Caesar',
    tag: 'work',
  },
  {
    id: 6416,
    quote: 'The hardest work of all: Doing nothing.',
    author: 'Malcolm Forbes',
    tag: 'work',
  },
  {
    id: 29,
    quote:
      'Without rest, a person cannot work; without work, the rest does not give you any benefit.',
    author: 'Abkhasian Proverb',
    tag: 'work',
  },
  {
    id: 6419,
    quote:
      'Working at what you enjoy is far more important than what you’re working at.',
    author: 'Malcolm Forbes',
    tag: 'work',
  },
  {
    id: 4466,
    quote:
      'People forget how fast you did a job—but they remember how well you did it.',
    author: 'Howard W. Newton',
    tag: 'work',
  },
  {
    id: 4580,
    quote:
      'If you want to leave your footprints on the sands of time, be sure you’re wearing work shoes.',
    author: 'Italian Proverb',
    tag: 'work',
  },
  {
    id: 9907,
    quote:
      'There is no boon in nature. All the blessings we enjoy are the fruits of labor, toil, self-denial, and study.',
    author: 'William Graham Sumner',
    tag: 'work',
  },
  {
    id: 10082,
    quote: 'Give me love and work—these two only.',
    author: 'William Morris',
    tag: 'work',
  },
  {
    id: '',
    quote:
      'Healing is a matter of time, but it is sometimes also a matter of opportunity.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Let food be thy medicine and medicine be thy food.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: "Walking is a person's best medicine.",
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote:
      'Wherever the art of medicine is loved, there is also a love of humanity.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Cure sometimes, treat often, comfort always.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Natural forces within us are the true healers of disease.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote:
      'If we could give every individual the right amount of nourishment and exercise, not too little and not too much, we would have found the safest way to health.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Make a habit of two things: to help; or at least to do no harm.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Everything in excess is opposed to nature.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote:
      'There are in fact two things, science and opinion; the former begets knowledge, the latter, ignorance.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'The life so short, the craft so long to learn.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Many admire, few know.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote:
      "A wise person should consider that health is the greatest of human blessings, and learn how by one's own thought to derive benefit from one's illnesses.",
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Extreme remedies are very appropriate for extreme diseases.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote: 'Life is short, the art long.',
    author: 'Hippocrates',
    tag: 'hippocrates',
  },
  {
    id: '',
    quote:
      'The good physician treats the disease; the great physician treats the patient who has the disease.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote: 'Medicine is a science of uncertainty and an art of probability.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      "The best preparation for tomorrow is to do today's work superbly well.",
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'Those who study medicine without books sail an uncharted sea, but those who study medicine without patients do not go to sea at all.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'The very first step towards success in any occupation is to become interested in it.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'The value of experience is not in seeing much, but in seeing wisely.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote: 'Soap and water and common sense are the best disinfectants.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote: 'The greater the ignorance the greater the dogmatism.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'Observe, record, tabulate, communicate. Use your five senses. Learn to see, learn to hear, learn to feel, learn to smell, and know that by practice alone you can become expert.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'Variability is the law of life, and as no two faces are the same, so no two bodies are alike, and no two individuals react alike and behave alike under the abnormal conditions which we know as disease.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'We are here to add what we can to life, not to get what we can from life.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'The young physician starts life with 20 drugs for each disease, and the old physician ends life with one drug for 20 diseases.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'No bubble is so iridescent or floats longer than that blown by the successful teacher.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'The first duty of the physician is to educate the masses, not to take medicine.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'To have striven, to have made the effort, to have been true to certain ideals—this alone is worth the struggle.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'Look wise, say nothing, and grunt. Speech was given to conceal thought.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'The philosophies of one age have become the absurdities of the next, and the foolishness of yesterday has become the wisdom of tomorrow.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'In seeking absolute truth we aim at the unattainable and must be content with broken portions.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'There are, in truth, no specialties in medicine, since to know fully many of the most important diseases a person must be familiar with their manifestations in many organs.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'No human being is constituted to know the truth, the whole truth, and nothing but the truth; and even the best of people must be content with fragments, with partial glimpses, never the full fruition.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'There is no disease more conducive to clinical humility than aneurysm of the aorta.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote:
      'It is much simpler to buy books than to read them and easier to read them than to absorb their contents.',
    author: 'William Osler',
    tag: 'osler',
  },
  {
    id: '',
    quote: "Believe you can and you're halfway there.",
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'You have to expect things of yourself before you can do them.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: "It always seems impossible until it's done.",
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: "Don't let what you cannot do interfere with what you can do.",
    author: 'John Wooden',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'Start where you are. Use what you have. Do what you can.',
    author: 'Arthur Ashe',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Successful and unsuccessful people do not vary greatly in their abilities. They vary in their desires to reach their potential.',
    author: 'John Maxwell',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Good things come to people who wait, but better things come to those who go out and get them.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'Strive for progress, not perfection.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'I find that the harder I work, the more luck I seem to have.',
    author: 'Thomas Jefferson',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'Success is the sum of small efforts, repeated day in and day out.',
    author: 'Robert Collier',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: "Don't wish it were easier; wish you were better.",
    author: 'Jim Rohn',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      "I don’t regret the things I’ve done. I regret the things I didn't do when I had the chance.",
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      "There are two kinds of people in this world: those who want to get things done and those who don't want to make mistakes.",
    author: 'John Maxwell',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'The secret to getting ahead is getting started.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'You don’t have to be great to start, but you have to start to be great.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'The expert in everything was once a beginner.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'There are no shortcuts to any place worth going.',
    author: 'Beverly Sills',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'Push yourself, because no one else is going to do it for you.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Some people dream of accomplishing great things. Others stay awake and make it happen.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'There is no substitute for hard work.',
    author: 'Thomas Edison',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'The difference between ordinary and extraordinary is that little “extra.”',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'You don’t always get what you wish for; you get what you work for.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'It’s not about how bad you want it. It’s about how hard you’re willing to work for it.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'The only place where success comes before work is in the dictionary.',
    author: 'Vidal Sassoon',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'There are no traffic jams on the extra mile.',
    author: 'Zig Ziglar',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      "If people only knew how hard I've worked to gain my mastery, it wouldn't seem so wonderful at all.",
    author: 'Michelangelo',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'If it’s important to you, you’ll find a way. If not, you’ll find an excuse.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Don’t say you don’t have enough time. You have exactly the same number of hours per day that were given to Helen Keller, Pasteur, Michelangelo, and Mother Teresea.',
    author: 'H. Jackson Brown Jr.',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Challenges are what make life interesting. Overcoming them is what makes life meaningful.',
    author: 'Joshua J. Marine',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'Life has two rules: 1) Never quit. 2) Always remember Rule #1.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'I’ve failed over and over and over again in my life. And that is why I succeed.',
    author: 'Michael Jordan',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      "I don’t measure a person's success by how high they climb, but how high they bounce when they hit the bottom.",
    author: 'George S. Patton',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: "If you're going through hell, keep going.",
    author: 'Winston Churchill',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Don’t let your victories go to your head, or your failures go to your heart.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'Failure is the opportunity to begin again more intelligently.',
    author: 'Henry Ford',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      "You don't drown by falling in the water; you drown by staying there.",
    author: 'Ed Cole',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'The difference between a stumbling block and a stepping-stone is how high you raise your foot.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'The pain you feel today is the strength you will feel tomorrow. For every challenge encountered there is opportunity for growth.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote: 'It’s not going to be easy, but it’s going to be worth it.',
    author: 'anonymous',
    tag: 'danielWong',
  },
  {
    id: '',
    quote:
      'Remember to look up at the stars and not down at your feet.  Be curious. And however difficult life may seem, there is always something you can do and succeed at. It matters that you just don’t give up.',
    author: 'Stephen Hawking',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'It’s a beautiful day to save lives.',
    author: 'Derek Shepherd, Grey’s Anatomy',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'Better is possible. It does not take genius. It takes diligence. It takes moral clarity. It takes ingenuity. And above all, it takes a willingness to try.',
    author: 'Atul Gawande',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Anything is possible if you’ve got enough nerve.',
    author: 'J.K. Rowling',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'Stay afraid, but do it anyway. What’s important is the action. You don’t have to wait to be confident. Just do it and eventually the confidence will follow.',
    author: 'Carrie Fisher',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'No matter how you feel, get up, dress up, show up, and never give up.',
    author: 'Regina Brett',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'Everyone has a doctor in him or her; we just have to help it in its work. The natural healing force within each one of us is the greatest force in getting well.',
    author: 'Hippocrates',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Medicine is not a book, but mind; not a business, but life.',
    author: 'Farid F. Ibrahim',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'The art is long, life is short, opportunity fleeting, experiment dangerous, judgement difficult.',
    author: 'Hippocrates',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Medicine is a science of uncertainty, and an art of probability.',
    author: 'William Osler',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'Learning medicine is like going from simple drawings to fine paintings.',
    author: 'Ted Kaptchuk',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Nothing worth doing is ever easy.',
    author: 'Theodore Roosevelt',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'We have purposes larger than ourselves.',
    author: 'Atul Gawande',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'When you have eliminated the impossible, whatever remains, however improbable, must be the truth.',
    author: 'Sir Arthur Conan Doyle',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'The glory of medicine is that it is constantly moving forward, that there is always more to learn. The ills of today do not cloud the horizon of tomorrow, but act as a spur to greater effort.',
    author: 'William James Mayo',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Medicine is only for those who cannot imagine doing anything else.',
    author: 'Dr. Luanda Grazette',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'Of course it’s hard. It’s supposed to be hard. If it was easy, everyone would do it. Hard is what makes it great.',
    author: 'Jimmy Dugan',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Let food be thy medicine, and let thy medicine be food.',
    author: 'Hippocrates',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'Never give up on a dream just because of the time it will take to accomplish it. The time will pass away.',
    author: 'Early Nightingale',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'The real heroes anyways aren’t the people doing things; the real heroes are the people noticing things, paying attention.',
    author: 'John Green',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Treat the patient, not the X-ray.',
    author: 'James Hunter',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote:
      'I’m not telling you it’s going to be easy—I’m telling you it’s going to be worth it.',
    author: 'Art Williams',
    tag: 'medicalSchool',
  },
  {
    id: '',
    quote: 'Try and fail, but never fail to try.',
    author: 'Jared Leto',
    tag: 'celebrity',
  },
  {
    id: '',
    quote: "Nothing is impossible; the word itself says, 'I'm possible!'",
    author: 'Audrey Hepburn',
    tag: 'celebrity',
  },
  {
    id: '',
    quote: 'Procrastination is the thief of time.',
    author: 'Edward Young',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'There is no secret to success. It is the result of preparation, hard work, and learning from failure.',
    author: 'General Colin Powell',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'Striving for success without hard work is like trying to harvest where you haven’t planted.',
    author: 'David Bly',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'There is no elevator to success. You have to take the stairs.',
    author: 'Zig Ziglar',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'Success is the sum of small efforts, repeated day-in and day-out.',
    author: 'Robert Collier',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'It is well to remind ourselves that anxiety signifies a conflict, and so long as a conflict is going on, a constructive solution is possible.',
    author: 'Rollo May',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'Education is the passport to the future, for tomorrow belongs to those who prepare for it today.',
    author: 'Malcolm X',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'Excellence is not a skill. It is an attitude.',
    author: 'Ralph Marston',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'You’ve got to get up every morning with determination if you’re going to go to bed with satisfaction.',
    author: 'George Lorimer',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'Courage doesn’t always roar. Sometimes courage is the quiet voice at the end of the day saying, ‘I will try again tomorrow.’',
    author: 'Mary Anne Radmacher',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'If you don’t go after what you want, you’ll never have it. If you don’t ask, the answer is always no. If you don’t step forward, you’re always in the same place.',
    author: 'Nora Roberts',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'So many of our dreams at first seem impossible, then they seem improbable, and then, when we summon the will, they soon become inevitable.',
    author: 'Christopher Reeve',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'It is not the mountain we conquer, but ourselves.',
    author: 'Edmund Hillary',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'The difference between ordinary and extraordinary is that little extra.',
    author: 'Jimmy Johnson',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'Perseverance is failing 19 times and succeeding the 20th.',
    author: 'Julie Andrews',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'Quality is not an act, but a habit.',
    author: 'Aristotle',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote:
      'Believe in yourself and all that you are. Know that there is something inside you that is greater than any obstacle.',
    author: 'Steven J. Ross',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'All progress takes place outside of your comfort zone.',
    author: 'Michael John Bobak',
    tag: 'collegeAmerica',
  },
  {
    id: '',
    quote: 'The journey is the reward.',
    author: 'Chinese Proverb',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'The best way to predict your future is to create it.',
    author: 'Abraham Lincoln',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do.',
    author: 'Pele',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'People who succeed have momentum.',
    author: 'Tony Robbins',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Only put off until tomorrow what you are willing to die having left undone.',
    author: 'Pablo Picasso',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'No profit grows where no pleasure taken. In brief: study what you most affect.',
    author: 'William Shakespeare',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Motivation is what gets you started. Habit is what keeps you going.',
    author: 'Jim Ryun',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'Learning is like rowing upstream, not to advance is to drop back.',
    author: 'Chinese Proverb',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'Learn from yesterday, live for today, hope for tomorrow.',
    author: 'Albert Einstein',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'It is wiser to find out than to suppose.',
    author: 'Mark Twain',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'In my experience, there is only one motivation, and that is desire.',
    author: 'Jane Smiley',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Education is what survives when what has been learned has been forgotten.',
    author: 'B. F. Skinner',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Education enables people to achieve their fullest mental and physical potential in both personal and social life.',
    author: 'Abhijit Naskar',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Do not wait to strike till the iron is hot; but make it hot by striking.',
    author: 'William Butler Yeats',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Be a student as long as you still have something to learn, and this will mean all your life.',
    author: 'Henry L. Doherty',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'All progress takes place outside the comfort zone.',
    author: 'Michael John Bobak',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'Acquiring knowledge is the most fruitful effort.',
    author: 'Eraldo Banovac',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'What seems to us as bitter trials are often blessings in disguise.',
    author: 'Oscar Wilde',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote: 'We do what we have to so we can do what we want to.',
    author: 'James Farmer',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'Try not to become a person of success, but rather try to become a person of value.',
    author: 'Albert Einstein',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'To acquire knowledge, one must study; but to acquire wisdom, one must observe.',
    author: 'Marilyn Vos Savant',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'The successful warrior is the average person, with laser-like focus.',
    author: 'Bruce Lee',
    tag: 'inspiringTips',
  },
  {
    id: '',
    quote:
      'The purpose of learning is growth, and our minds, unlike our bodies, can continue growing as long as we live.',
    author: 'Mortimer Adler',
    tag: 'inspiringTips',
  },
];
